import { createRouter, createWebHistory } from 'vue-router'
import { getAccessToken } from '../stores/auth'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/rules',
    name: 'Rules',
    component: () => import('../views/Rules.vue')
  },
  {
    path: '/howtostart',
    name: 'HowToStart',
    component: () => import('../views/HowToStart.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/AboutGame.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/auth/callback',
    name: 'AuthCallback',
    component: () => import('../views/AuthCallback.vue')
  },
  {
    path: '/admin',
    name: 'AdminHub',
    component: () => import('../views/AdminHub.vue')
    // No auth required - guests can host games; Google login is an optional upgrade
  },
  {
    path: '/lobby/:gameId',
    name: 'Lobby',
    component: () => import('../views/Lobby.vue'),
    props: true
  },
  {
    path: '/game/:gameId',
    name: 'Game',
    component: () => import('../views/Game.vue'),
    props: true
  },
  // Three-Page Architecture Routes
  {
    path: '/host/:gameId',
    name: 'Host',
    component: () => import('../views/Host.vue'),
    props: true
    // No auth required - guests can host games; Google login is an optional upgrade
  },
  {
    path: '/stream/:gameId',
    name: 'Stream',
    component: () => import('../views/Stream.vue'),
    props: true
    // No auth required - Stream is public for viewers
  },
  {
    path: '/play/:gameId',
    name: 'Play',
    component: () => import('../views/Play.vue'),
    props: true
  },
  {
    path: '/demo',
    name: 'DemoPlay',
    component: () => import('../views/DemoPlay.vue')
  },
  // Redirects
  {
    path: '/host',
    redirect: '/admin'
  },
  {
    path: '/stream',
    redirect: '/admin'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach(async (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const token = await getAccessToken()
    if (!token) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router



